import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import ko from './ko'
import ja from './ja'
import ar from './ar'
import es from './es'
import id from './id'
import ms from './ms'
import pt from './pt'
import th from './th'
import vi from './vi'

Vue.use(VueI18n)

const messages = {
  zh,
  en,
  ko,
  ja,
  ar,
  es,
  id,
  ms,
  pt,
  th,
  vi,
}

export const generationLanguage = () => {
  const cacheLanguage = localStorage.getItem('CURRENT_LANGUAGE')
  const supportLanguages = Object.keys(messages)
  const systemLanguage = navigator.language
  if (cacheLanguage) {
    return cacheLanguage
  }
  const defaultLanguages = supportLanguages.filter(
    // eslint-disable-next-line comma-dangle
    lang => lang === systemLanguage
  )
  return defaultLanguages.length ? defaultLanguages[0] : supportLanguages[0]
}

console.log('当前浏览器语言：' + generationLanguage())

const i18n = new VueI18n({
  locale: generationLanguage(),
  fallbackLocale: 'en',
  messages,
})

const setDirection = lang => {
  document.documentElement.lang = lang
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
}

setDirection(i18n.locale)

export const switchLanguage = lang => {
  i18n.locale = lang
  localStorage.setItem('CURRENT_LANGUAGE', lang)
}

export default i18n
